import React from 'react'

export default function listStyles(itemsPerRow, device) {
    if (itemsPerRow == 1) {
      if (device != 'desktop') {
        return `
          .service-item {
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            width: 100%;
          }
          .services-list .service-item.classic-style .service-text {
            padding: 0px 20px 20px 20px;
          }
          .service-item .service-image {
            width: 100%;
          }
        `
      } else {
        return `
          .services-list .service-item.classic-style .service-image,
          .services-list .service-item.classic-style .service-text {
            width: 50%;
          }
          .services-list .service-item.classic-style .service-text {
            padding: 20px;
          }
          .service-item {
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: flex;
            flex-wrap: wrap;
            width: 100%;
          }
        `
      }

    } else if (itemsPerRow == 2) {
      return `
        @media screen and (min-width:600px) {
          .service-item {
            width: calc( 95% / 2 );
            margin-right: calc( 5% / 2 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }
      `

    } else if (itemsPerRow == 3) {
      return `
        @media screen and (min-width:600px) {
          .service-item {
            width: calc( 95% / 2 );
            margin-right: calc( 5% / 2 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }

        @media screen and (min-width:750px) {
          .service-item {
            width: calc( 95% / 3 );
            margin-right: calc( 5% / 3 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }
      `
    } else if (itemsPerRow == 4) {
      return `
        @media screen and (min-width:410px) {
          .service-item {
            width: calc( 95% / 2 ) !important;
            margin-right: calc( 5% / 2 ) !important;
          }
          .service-item:last-child {
            margin-right: 0px !important;
          }
        }

        @media screen and (min-width:750px) {
          .service-item {
            width: calc( 95% / 3 ) !important;
            margin-right: calc( 5% / 3 ) !important;
          }
          .service-item:last-child {
            margin-right: 0px !important;
          }
        }

        @media screen and (min-width:800px) {
          .service-item {
            width: calc( 95% / 4 ) !important;
            margin-right: calc( 5% / 4 ) !important;
          }
          .service-item:last-child {
            margin-right: 0px !important;
          }
        }
      `
    } else if (itemsPerRow == 5) {
      return `
        @media screen and (min-width:600px) {
          .service-item {
            width: calc( 95% / 2 );
            margin-right: calc( 5% / 2 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }

        @media screen and (min-width:750px) {
          .service-item {
            width: calc( 95% / 3 );
            margin-right: calc( 5% / 3 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }

        @media screen and (min-width:800px) {
          .service-item {
            width: calc( 95% / 4 );
            margin-right: calc( 5% / 4 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }

        @media screen and (min-width:1000px) {
          .service-item {
            width: calc( 95% / 5 );
            margin-right: calc( 5% / 5 );
          }
          .service-item:last-child {
            margin-right: 0px;
          }
        }
      `
    }

  return ''
}
